import { useEffect, useState } from "react";
import { Box, Typography, IconButton, Tooltip, Avatar, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getUsers } from "../../api/users";
import { CardContainer, PairCard } from "./UsersList.styled";
import { Person } from "./types";
import { copyToClipboard } from "../../utils/clipboard";

export function UsersList() {
  const [users, setUsers] = useState<Person[]>([]);

  useEffect(() => {
    getUsers()
        .then(setUsers)
        .catch(() => setUsers([]));
  }, []);

  return (
      <CardContainer>
        {users.map((user) => (
            <PairCard key={user.id}>
              <Avatar sx={{ bgcolor: "#f5a623", width: 50, height: 50, marginRight: 2 }}>
                {user.name?.[0]?.toUpperCase() || "U"}
              </Avatar>
              <Box flex={1}>
                <Stack spacing={0.5}>
                  <Typography variant="h6" color="primary">
                    {user.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Role: {user.role}
                  </Typography>
                </Stack>
              </Box>
              <Tooltip title="Copy ID">
                <IconButton onClick={() => copyToClipboard(user.id)}>
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </PairCard>
        ))}
      </CardContainer>
  );
}
